import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements, Navigate } from 'react-router-dom'
import Home from '../views/Home/index'
import Activities from '../views/Activities/index'
import Researchs from '../views/Researchs/index'
import MethodologyDetail from '../views/Methodology/Detail'
import About from '../views/About/index'
import RootLayout from '../layouts/RootLayout'
import ActivitiesDetail from '../views/Activities/Detail'
import ContactUs from '../views/ContactUs/Index'
import IndicatorDisplay from '../views/IndicatorDisplay/index'
import Evaluador from '../views/Evaluator/index'
import ODS from '../views/ODS/index'
import PriorityGroups from '../views/PriorityGroups/index'
import Unsuscribe from '../views/Unsubscribe/Unsuscribe'
import UnsubscribeSuccess from '../views/Unsubscribe/UnsubscribeSuccess'
import UnsubscribeError from '../views/Unsubscribe/UnsubscribeError'
import OpenData from '../views/OpenData/index'
import IndicatorIndex from '../views/IndicatorIndex/index'

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route
            element={<RootLayout />}
        >
            <Route path='/monitor'>
                <Route index element={<Home />} />
                <Route path='visualizador-de-indicadores' element={<IndicatorDisplay />} />
                <Route path='actividades'>
                    <Route index element={<Activities />} />
                    <Route path=':title' element={<ActivitiesDetail />} />
                </Route>
                <Route path='informes'>
                    <Route index element={<Researchs />} />
                </Route>
                <Route path='metodologia' element={<MethodologyDetail />} />
                <Route path='que-es' element={<About />} />
                <Route path='contactanos' element={<ContactUs />} />
                <Route path='evaluador' element={<Evaluador />} />
                <Route path='ods'>
                    <Route path=':id' element={<ODS />} />
                </Route>
                <Route path='grupos-prioritarios'>
                    <Route path=':id' element={<PriorityGroups />} />
                </Route>
                <Route path='cancelar-suscripcion'>
                    <Route path=':id' element={<Unsuscribe />} />
                    <Route path='exito' element={<UnsubscribeSuccess />} />
                    <Route path='error' element={<UnsubscribeError />} />
                </Route>
                <Route path='datos-abiertos' element={<OpenData />} />
                <Route path='indice-indicadores' element={<IndicatorIndex />} />
            </Route>
            <Route path='*' element={<Navigate to='/monitor' replace />} />
        </Route>
    )
)

const Root = () => {

    return (
        <RouterProvider router={router} />
    )
}

export default Root